import React from 'react';
import RightPanel from './rightPanel';
import CenterPanel from './centerPanel';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';
import { useSelector } from 'react-redux';

const ContentResetPassword = (props) => {
  const resetingPassword = useSelector((state) => state.usersReducer.resetingPassword);
  const userEmailForPasswordReset = useSelector((state) => state.usersReducer.userEmailForPasswordReset);
  const showModal = useSelector((state) => state.modalReducer.showResetPasswordTokenModal);
  const browser = useSelector((state) => state.browser);

  const openForgotPasswordHelp = () => {
    window.open(APP.EXTERNAL_LINKS.Login.ResetPassword, '_blank');
  };

  return (
    <Modal show={showModal} hideWhenClickAway={false} className="ui modal reset-password">
      <PopupHeader hideHelp={true} title={APP.LANGUAGE.ResetPassword.Title} />

      <div className="content">
        <div className="main-ui-container user-reset-password">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">
                <RightPanel
                  resetingPassword={resetingPassword}
                  passwordResetRequestCompleted={props.passwordResetRequestCompleted}
                />
              </div>
            </div>
            <CenterPanel browser={browser} passwordResetRequestCompleted={props.passwordResetRequestCompleted} />
            <div className="bottom-rail-with-left-and-right-content">
              <RightPanel
                resetingPassword={resetingPassword}
                passwordResetRequestCompleted={props.passwordResetRequestCompleted}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ContentResetPassword;
